// extracted by mini-css-extract-plugin
export var quillEditor = "_pk-1";
export var variable = "_pk-0";